module.exports = __webpack_public_path__ + "img/cheers.ed4b443b.png";